import { ShortClipView } from '../components/ShortClipView';
import { useShortClipService } from '../services/useShortClipService';

export const ShortClipContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const {
    isSingleList,
    shortClipContentList,
    handleActiveIndexChange,
    targetRef,
    isRevealed,
    activeIndex,
    handleShortClipClick,
    productId,
    isHide,
  } = useShortClipService();

  if (isHide) return null;

  return (
    <div ref={targetRef}>
      <ShortClipView
        isSingleList={isSingleList}
        shortClipContentList={shortClipContentList}
        handleActiveIndexChange={handleActiveIndexChange}
        isRevealed={isRevealed}
        activeIndex={activeIndex}
        handleShortClipClick={handleShortClipClick}
        productId={productId}
      />
    </div>
  );
};
